import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CAPTION_BACKGROUND_PADDING_X_RANGE,
  CAPTION_BACKGROUND_PADDING_Y_RANGE,
  CAPTION_BLUR_RANGE,
  CAPTION_BORDER_RADIUS_RANGE,
} from '@vbee-holding/aivoice-shared-lib';
import GroupHeader from './controls/GroupHeader';
import ConfigRow from './controls/ConfigRow';
import SliderField from './controls/SliderField';
import ColorField from './controls/ColorField';

const CONTROL_WIDTH = 200;

const BackgroundGroup = ({ background, onChange }) => {
  const { t } = useTranslation();
  const { enabled } = background;

  return (
    <div className="config-group">
      <GroupHeader
        label={t('captionBackground')}
        enabled={enabled}
        onToggle={(next) => onChange({ enabled: next })}
      />

      <div className="config-group-rows">
        <ConfigRow label={t('captionColor')} disabled={!enabled}>
          <ColorField
            value={background.color}
            opacity={background.opacity}
            disabled={!enabled}
            onChange={(color) => onChange({ color })}
            onOpacityChange={(opacity) => onChange({ opacity })}
          />
        </ConfigRow>

        <ConfigRow label={t('captionBorderBlur')} disabled={!enabled}>
          <SliderField
            width={CONTROL_WIDTH}
            value={background.blur}
            range={CAPTION_BLUR_RANGE}
            onChange={(blur) => onChange({ blur })}
          />
        </ConfigRow>

        <ConfigRow label={t('captionBorderRadius')} disabled={!enabled}>
          <SliderField
            width={CONTROL_WIDTH}
            value={background.borderRadius}
            range={CAPTION_BORDER_RADIUS_RANGE}
            onChange={(borderRadius) => onChange({ borderRadius })}
          />
        </ConfigRow>

        <ConfigRow label={t('captionPaddingX')} disabled={!enabled}>
          <SliderField
            width={CONTROL_WIDTH}
            value={background.paddingX}
            range={CAPTION_BACKGROUND_PADDING_X_RANGE}
            suffix="%"
            onChange={(paddingX) => onChange({ paddingX })}
          />
        </ConfigRow>

        <ConfigRow label={t('captionPaddingY')} disabled={!enabled}>
          <SliderField
            width={CONTROL_WIDTH}
            value={background.paddingY}
            range={CAPTION_BACKGROUND_PADDING_Y_RANGE}
            suffix="%"
            onChange={(paddingY) => onChange({ paddingY })}
          />
        </ConfigRow>
      </div>
    </div>
  );
};

export default BackgroundGroup;
